import styled from 'styled-components';
import { convertArrayToShortText, cutLongText } from '../../../helpers';
import HealtheraTable from '../../Table/Table';
import LoadingCell from '../components/Loading/LoadingCell';

const ConsultationsTable = ({
  consultations,
  onRowsPerPageChange,
  onPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  total,
  isLoading,
}) => {
  const preparedData = isLoading
    ? prepareLoadingData(rowsPerPage)
    : prepareData({ consultations });

  return (
    <HealtheraTable
      data={preparedData}
      muted
      totalCount={total}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onChangePage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      page={page}
      displayPagination
    />
  );
};

const headers = {
  view: {
    title: { title: 'Service Name', width: '25%' },
    description: { title: 'Description', width: '20%' },
    type: { title: 'Type of service', width: '20%' },
    offered_by_pharmacy_count: { title: 'Offered by pharmacies', width: '20%' },
    conditions: { title: 'Conditions', width: '15%' },
  },
  headers: true
};

const prepareLoadingData = (rowsPerPage) => {
  return Array.from({ length: rowsPerPage }).reduce(
    data => {
      data.push({
        view: {
          title: <LoadingCell />,
          description: <LoadingCell />,
          type: <LoadingCell />,
          offered_by_pharmacy_count: <LoadingCell />,
          conditions: <LoadingCell />,
        }
      });
      return data;
    },
    [headers]
  );
};

const prepareData = ({ consultations }) => {
  if (!consultations) {
    return [];
  }

  const rows = consultations.map((consultation) => {
    const { _id, title, description, type, offered_by_pharmacy_count, consultation: { conditions } = { conditions: [] } } = consultation;

    return {
      view: {
        title,
        description: <ServiceDescription>{description ? cutLongText(description, 30) : ''}</ServiceDescription>,
        type,
        offered_by_pharmacy_count,
        conditions: convertArrayToShortText(conditions),
      },
      ID: _id,
      route: 'services/consultations'
    };
  });

  return [headers, ...rows];
};


const ServiceDescription = styled.p`
padding: 0px;
`;

export default ConsultationsTable;
